import {getJsonRequest} from '~/src/utilities/helpers/request';
import {getFeedUrl} from '~/src/utilities/helpers/feed';
import {SiteArea} from '~/src/utilities/constants/navigation';
import {structureSitemap, flattenSitemap} from '~/server/utils/sitemap';
import {Logger} from '~/src/utilities/helpers/log';

const updateSitemap = async () => {
    try {
        const navigation = await getJsonRequest(getFeedUrl('sitemap', null));
        return structureSitemap(navigation.sitemap);
    } catch (error) {
        Logger.info(`[${error.name}][Sitemap] errror fetching sitemap from feed`, {error});

        return [];
    }
};

const getCategoryList = (categories) => {
    return flattenSitemap(categories);
};

const getSubset = (categories, siteArea) => {
    switch (siteArea) {
        case SiteArea.VIDEO:
            const videoCategory = getCategoryBy(categories, {fullUrlPath: 'video'});
            return (videoCategory && videoCategory.children) || [];
        case SiteArea.LIFESTYLE:
            const lifestyleCategory = getCategoryBy(categories, {fullUrlPath: 'lifestyle'});
            return (lifestyleCategory && lifestyleCategory.children) || [];
        default:
            return categories;
    }
};

const getCategoryBy = (categories, query) => {
    return categories.find((category) => {
        return Object.keys(query).every((key) => query[key] && category[key] === query[key]);
    });
};

export {updateSitemap, getCategoryBy, getCategoryList, getSubset};
